export const /** @type {?} */ INPUT_TYPE = {
  phone: 'phone',
  pin: 'pin',
};

export const /** @type {?} */ AUTH_TYPE = {
  login: 'login',
  otp: 'OTP',
};

export const /** @type {?} */ OTP = {
  otp1: 'otp_1',
  otp2: 'otp_2',
  otp3: 'otp_3',
  otp4: 'otp_4',
};
